import React, { useEffect, useState } from "react";

const UpdatesWidget = () => {
  const [updates, setUpdates] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // State for loading

  // Fetch data and set state
  useEffect(() => {
    fetch(
      "https://script.google.com/macros/s/AKfycbwibFjNFNbwRbs1ctCRPp61j_6s-h4ub50Y1X4ggMvEq9aZ_lGo3Aradqrlcc8iJlvB/exec"
    )
      .then((response) => response.json())
      .then((data) => {
        const lastFiveObjects = data.reverse().slice(-5).reverse();
        console.log(lastFiveObjects);
        setUpdates(lastFiveObjects);
      })
      .finally(() => {
        setIsLoading(false); // Set loading to false once data is fetched
      });
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#000",
        color: "white",
        padding: "1.5em",
        textAlign: "left",
        width: "100%",
      }}
    >
      <h4 className="pb-3" style={{ color: "#eab308" }}>
        Restraint Chair Updates
      </h4>

      {isLoading ? (
        // Loading animation
<div  class="spinner"></div>

      ) : (
        // Updates content
        <div className="updates-grid">
          {updates.map((update, index) => (
            <div className="update-item" key={index}>
              <a href="https://illinoisanswers.org/?p=21480&preview=true">
                <h5 className="pb-2">{update.title}</h5>
              </a>
              <p className="pb-2">{update.description_summ}</p>
              <p>{update.date}</p>
              <hr className="my-2"></hr>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UpdatesWidget;
